module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-11.9aaa9e50.jpg";